module.exports = __webpack_public_path__ + "static/media/Navi.21166ce5.svg";